import { render, staticRenderFns } from "./UserDocumentUpdateModal.vue?vue&type=template&id=67072a6b&scoped=true&"
import script from "./UserDocumentUpdateModal.vue?vue&type=script&lang=js&"
export * from "./UserDocumentUpdateModal.vue?vue&type=script&lang=js&"
import style0 from "./UserDocumentUpdateModal.vue?vue&type=style&index=0&id=67072a6b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67072a6b",
  null
  
)

export default component.exports